import { useId } from "react";

// A small illustration for the public sample. The lesson itself uses the wall's 3D scene.
// Ids are per instance so the hero card and the dialog can both show it.
export default function ShoeArt({ className = "shoe-art" }: { className?: string }) {
  const id = useId().replace(/:/g, "");
  const ref = (name: string) => `${id}-${name}`;
  return (
    <svg viewBox="0 0 470 255" aria-hidden="true" className={className}>
      <defs>
        <linearGradient id={ref("upper")} x2=".6" y2="1">
          <stop stopColor="#858dc1" />
          <stop offset="1" stopColor="#515782" />
        </linearGradient>
        <linearGradient id={ref("sole")} x2="0" y2="1">
          <stop stopColor="#fffbea" />
          <stop offset="1" stopColor="#d9d7ba" />
        </linearGradient>
        <linearGradient id={ref("toe")} x2="1" y2="1">
          <stop stopColor="#b9d9b0" />
          <stop offset="1" stopColor="#83b59f" />
        </linearGradient>
        <g id={ref("shoe")}>
          <path
            d="M6 60 Q7 35 15 29 Q26 42 43 38 Q55 33 67 16 Q72 9 79 16 L113 55 Q129 71 164 75 Q184 78 188 92 Q189 104 179 106 L33 107 Q8 106 5 91 Z"
            fill={`url(#${ref("upper")})`}
            stroke="#3f4363"
            strokeWidth="3"
          />
          <path d="M14 30 Q30 49 50 39 L65 21 Q59 43 49 48 Q31 55 14 41Z" fill="#424866" />
          <path d="M12 55 Q29 72 50 60 L60 81 L32 96 L10 86Z" fill="#a9c9a3" />
          <path
            d="M117 62 Q131 73 163 77 Q182 80 186 94 L135 94 Q124 89 117 62Z"
            fill={`url(#${ref("toe")})`}
          />
          <path
            d="M5 86 Q24 96 52 96 L187 91 Q191 100 184 109 Q79 120 24 113 Q6 111 4 101Z"
            fill={`url(#${ref("sole")})`}
            stroke="#555c5a"
            strokeWidth="2.6"
          />
          <path
            d="M10 101 Q31 113 67 109 L180 102"
            fill="none"
            stroke="#a9a98f"
            strokeWidth="2"
            strokeDasharray="4 6"
          />
          <g stroke="#fff3dc" strokeWidth="9" strokeLinecap="round">
            <path d="m70 31 21 -2" />
            <path d="m78 41 22 -1" />
            <path d="m86 51 22 1" />
          </g>
          <path d="m53 68 25 -7 -8 11 -20 8Z" fill="#f6c267" />
        </g>
      </defs>
      <ellipse cx="238" cy="213" rx="143" ry="20" fill="#b2caa3" opacity=".45" />
      <g transform="translate(162 57) rotate(-11) scale(.97)">
        <use href={`#${ref("shoe")}`} />
      </g>
      <g transform="translate(83 96) rotate(6) scale(1.17)">
        <use href={`#${ref("shoe")}`} />
      </g>
      <g fill="#f4b84f">
        <path d="m76 47 4 13 13 4 -13 4 -4 13 -4 -13 -13 -4 13 -4z" />
        <path d="m378 141 3 9 10 3 -10 4 -3 9 -3 -9 -10 -4 10 -3z" />
      </g>
      <g stroke="#779755" strokeWidth="3" strokeLinecap="round" fill="#a3c17b">
        <path d="M361 81q2-17 15-25q3 16-15 25Z" />
        <path d="M361 81q-14-3-15-15q13 1 15 15Z" />
      </g>
      <g fill="#e7b7bd">
        <circle cx="100" cy="204" r="3" />
        <circle cx="392" cy="103" r="4" />
      </g>
    </svg>
  );
}

/** Wall-app task stickers, drawn as in Buddy Garden. */
export function Sticker({ kind, size }: { kind: "ready" | "bed"; size: number }) {
  return (
    <svg
      viewBox="0 0 60 60"
      width={size}
      height={size}
      aria-hidden="true"
      stroke="#615768"
      strokeWidth="2"
      strokeLinejoin="round"
      strokeLinecap="round"
    >
      {kind === "ready" ? (
        <>
          <path d="M7 26q6 7 14 3l9-12 7 7 2 7 9 5q6 1 6 9H7z" fill="#9386cb" />
          <path d="M39 31q17 5 15 12H42z" fill="#a4d2b3" />
          <path d="M7 41q19 3 47 0v7q-21 4-47 0z" fill="#fff0d3" />
          <path d="m29 23 8-1m-5 7 7-1" stroke="#fff2d7" strokeWidth="3" />
          <path d="m16 37 8-3-3 4z" fill="#ffd576" stroke="none" />
        </>
      ) : (
        <>
          <path d="M7 15v34m44-18v18" stroke="#895d45" strokeWidth="5" />
          <path d="M9 29h39q4 0 4 5v7H9z" fill="#72b9ac" />
          <path d="M10 25q4-9 13-5l6 6v5H10z" fill="#fff3c9" />
          <path d="M28 23h17q7 1 7 9H28z" fill="#a48ccc" />
          <path d="M9 39h42v5H9z" fill="#cd9964" />
          <path d="m31 27 2-3m7 3 2-3" stroke="#f2d9f0" />
        </>
      )}
    </svg>
  );
}
